import buildUrlLocation from "../helpers/buildUrlLocation";
import fetchClient from "../helpers/fetchClient";

/**
 * Triggers a goal by calling the API endpoint.
 * This function is reusable and can be imported elsewhere.
 *
 * @param {Object} params
 * @param {string} params.goalId - GUID of the Sitecore goal
 * @param {string} [params.goalName] - Optional goal name for logging/debugging
 * @param {string} [params.eventType] - Event type that triggered this goal (click, videoPlay, etc.)
 */
export async function triggerAnalyticsGoal({ goalId, goalName = '', eventType = '' }) {
    if (!goalId) {
      return;
    }
  
    // api - /api/loomis/analytics-tracking/triggerGoal
    // sc - /analyticstracking/triggergoal
    try {
      const response = await fetch("/api/Sitecore/analyticstracking/triggergoal", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ goalId, goalName, eventType })
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        console.warn("Failed to trigger goal:", goalId, data?.errors || data);
        return;
      }
  
      console.info(`Goal "${goalName || goalId}" triggered successfully.`);
    } catch (error) {
      console.error("Error triggering analytics goal:", error);
    }
  }

export async function triggerAnalyticsGoalById(goalId) {
    let url = buildUrlLocation(true, `/api/track-goal/${goalId}`);
  
}

/**
 * Automatically wires up click-based goal tracking by scanning DOM for elements
 * with analytics tracking attributes.
 *
 * Use data-analytics-track="true" and data-analytics-goal-id="<GUID>" etc.
 */
function registerClickGoalHandlers() {
  const trackableElements = document.querySelectorAll('[data-analytics-track="true"]');

  console.log(`Found ${trackableElements.length} trackable elements for goal tracking`);

  trackableElements.forEach((el) => {
    const eventType = el.dataset.analyticsEventType || "click";
    const goalId = el.dataset.analyticsGoalId;
    const goalName = el.dataset.analyticsGoalName || '';

    console.log(`Registering goal tracking for "${goalName}" with Id: ${goalId} on ${eventType} event`);

    if (!goalId) return;

    el.addEventListener(eventType, (e) => {
      triggerAnalyticsGoal({ goalId, goalName, eventType });
    });
  });
}

document.addEventListener("DOMContentLoaded", registerClickGoalHandlers);